import React, { useContext } from "react";
import cx from "classnames";

import { TSizes } from "../types";
import { ThemeContextNuO } from "../nuorder-theme";
import { useStyles } from "./avatar.styles";
import { DATATEST } from "./constants";

type TAvatarProps = {
    size?: Extract<TSizes, "default">;
    children: React.ReactNode;
    className?: string;
};

export const Avatar: React.FC<TAvatarProps> = ({ size = "default", ...props }) => {
    const themeContextNuO = useContext(ThemeContextNuO);
    const styles = useStyles(themeContextNuO);

    return (
        <div className={cx(styles.root, props.className, styles[`${size}Size`])} data-test={DATATEST.root}>
            {props.children}
        </div>
    );
};
